import axios from "axios";
import { EXTERNAL_SERVICE_BASE } from '../constants';
import { getHeaders } from './AuthService';

export const getWeather = async (siteId) => {
    let results = await axios.get(`${EXTERNAL_SERVICE_BASE()}/weather/current/site/${siteId}`, 
        { headers: await getHeaders() }
    );
    console.log(results)
    return results && results.data;
  };

